import { and, eq, gte, lte } from "drizzle-orm";
import { order, order_line, payment, type PowerSyncDrizzleDB } from "@comandero/powersync";
import { liveOrderFilters, liveOrderLineFilters, livePaymentFilters } from "../live/filters";

/**
 * Órdenes de una sucursal en un rango [fromISO, toISO] por `closed_at`. El rango
 * es opcional; sin él trae todas las órdenes (no borradas) de la sucursal. Las
 * agregaciones (totales, por hora, por empleado) viven en `sales-report.ts`.
 */
export function getReportOrdersQuery(
  db: PowerSyncDrizzleDB,
  organizationId: string,
  branchId: string,
  range?: { fromISO?: string; toISO?: string },
) {
  const filters = [
    eq(order.organization_id, organizationId),
    eq(order.branch_id, branchId),
    ...liveOrderFilters(),
  ];
  if (range?.fromISO) {
    filters.push(gte(order.closed_at, range.fromISO));
  }
  if (range?.toISO) {
    filters.push(lte(order.closed_at, range.toISO));
  }
  return db
    .select()
    .from(order)
    .where(and(...filters));
}

/**
 * Todas las líneas de orden de la org (para ventas por producto). La cohorte
 * `liveOrderLineFilters` excluye líneas cuya ORDEN está anulada (soft-delete),
 * que el filtro por-línea suelto no veía — corrige el doble conteo de anuladas.
 */
export function getReportLinesQuery(db: PowerSyncDrizzleDB, organizationId: string) {
  return db
    .select()
    .from(order_line)
    .where(and(eq(order_line.organization_id, organizationId), ...liveOrderLineFilters()));
}

/**
 * Todos los pagos de la org (para propinas y atribución por empleado). La cohorte
 * `livePaymentFilters` excluye pagos de órdenes anuladas (propinas fantasma).
 */
export function getReportPaymentsQuery(db: PowerSyncDrizzleDB, organizationId: string) {
  return db
    .select()
    .from(payment)
    .where(and(eq(payment.organization_id, organizationId), ...livePaymentFilters()));
}
